/* eslint-disable import/no-cycle */
import { EmployeeActionRequiredType, EmployeeStatus, EmployeeType, IEmployeeSite, SiteRole } from './Employee';
import { IOrganization } from './Organization';

export enum InviteStatus {
  ACCEPTED = 'accepted',
  DECLINED = 'declined',
  EXPIRED = 'expired',
  NOT_SENT = 'not_sent',
  PENDING = 'pending',
  SEND_FAILURE = 'send_failure',
}

export interface InvitationDisplay {
  orgName: string;
  role: SiteRole;
  displayRole: string;
  siteName?: string;
}

export interface InviteParamsUrl {
  inviteToken: string;
}

export interface IInviteEmployee {
  id: string;
  type: EmployeeType;
  sites: IEmployeeSite[];
  organization: IOrganization;
  status: EmployeeStatus;
  actionRequired?: EmployeeActionRequiredType;
  createdAt: string;
  updatedAt: string;
}

interface IInviteBase {
  id: string;
  status: InviteStatus;
}

export interface IInvite extends IInviteBase {
  employee: IInviteEmployee;
  createdAt: string;
  updatedAt: string;
}

export interface IInviteVerify extends IInviteBase {}

export interface IUserInvites {
  invites: IInvite[];
}
